import { useAsyncLoader } from '@aboutyou/legacy-shared/src/utils/hooks/useAsyncLoader'
import React from 'react'
import styled, { css } from 'styled-components'

import { FEMALE, MALE } from 'constants/gender'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { useRouter } from 'helpers/navigation'
import { getOppositeGenderCategory } from 'helpers/slug'
import { translateGender } from 'helpers/translateGender'
import { useService } from 'services/utils/context'
import { useLocaleStore, useUrlManagerStore, useUserStore } from 'store/context'
import ActionButton from 'uiComponents/atoms/Buttons/ActionButton'
import { darkGrayColor } from 'uiComponents/constants/colors'

const StyledActionButton = styled(ActionButton)<{ noBorder: boolean }>`
  :first-child {
    margin-right: 10px;
  }

  ${({ noBorder }) =>
    noBorder &&
    css`
      color: ${darkGrayColor};
      border-color: transparent;
    `};
`

interface IProps {
  className?: string
}

const GenderSwitch: React.FC<IProps> = ({ className }) => {
  const [shouldUseUnisexTabs, setShouldUseUnisextabs] = React.useState(false)
  const urlMangerStore = useUrlManagerStore()
  const service = useService()
  const { gender } = useUserStore()
  const { t } = useTranslation()
  const { navigateClientWithParams } = useRouter()
  const { pathname } = urlMangerStore
  const { locale } = useLocaleStore()
  const oppositeGenderCategoryPath = getOppositeGenderCategory({
    gender,
    pathname,
    locale,
  })

  const oppositeGenderCategoryHandler = React.useCallback(() => {
    return service.categories.requestByPathname(oppositeGenderCategoryPath)
  }, [oppositeGenderCategoryPath])

  const oppositeGenderCategory = useAsyncLoader(oppositeGenderCategoryHandler)

  React.useEffect(() => {
    if (oppositeGenderCategory instanceof Error) {
      setShouldUseUnisextabs(false)
      return
    }

    setShouldUseUnisextabs(
      Boolean(oppositeGenderCategory && oppositeGenderCategory.id),
    )
  }, [oppositeGenderCategory])

  if (!shouldUseUnisexTabs) {
    return null
  }
  const maleUrl = gender !== MALE ? oppositeGenderCategoryPath : pathname
  const femaleUrl = gender !== FEMALE ? oppositeGenderCategoryPath : pathname

  return (
    <span className={className}>
      <StyledActionButton
        title={translateGender(t, 'female')}
        noBorder={gender !== FEMALE}
        href={femaleUrl}
        onClick={navigateClientWithParams(femaleUrl)(urlMangerStore.params)}
      />
      <StyledActionButton
        title={translateGender(t, 'male')}
        noBorder={gender !== MALE}
        href={maleUrl}
        onClick={navigateClientWithParams(maleUrl)(urlMangerStore.params)}
      />
    </span>
  )
}

export default GenderSwitch
